import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { Link } from 'react-router-dom';
import useLogout from '../../hooks/useLogout';
import Loader from '../Loader';
import Alert from '../Alert';
import { SERVER_BASE_URL } from '../../config/app.config';
import { useLanguage } from '../../context/LanguageContext';

function ProfileSection({ user, error }) {
    const { t } = useLanguage();

    useEffect(() => {
        feather.replace();
    }, []);

    const { handleLogout, loading } = useLogout();

    return (
        <>
            <Loader loading={loading} />

            <section className="section-b-space">
                {error && <Alert alert={'danger'}>{error}</Alert>}

                <div className="custom-container">
                    <div className="profile-section">
                        <div className="profile-banner">
                            <div className="profile-image">
                                <img
                                    className="img-fluid profile-pic"
                                    src={
                                        user.profile_image
                                            ? `${SERVER_BASE_URL}/images/profile_image/${user.profile_image}`
                                            : 'assets/images/person/p0.webp'
                                    }
                                    alt="Profile"
                                    referrerPolicy="no-referrer"
                                />
                            </div>
                        </div>
                        <h2>{user.username}</h2>
                        <h5>{user.email}</h5>
                    </div>

                    <ul className="profile-list">
                        <li>
                            <Link to="/my-account" state={{ user }} className="profile-box">
                                <div className="profile-img">
                                    <i className="icon" data-feather="user"></i>
                                </div>
                                <div className="profile-details">
                                    <h4>{t('myAccount')}</h4>
                                    <img
                                        className="img-fluid arrow"
                                        src={'assets/images/svg/arrow.svg'}
                                        alt="arrow"
                                    />
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/password-update" className="profile-box">
                                <div className="profile-img">
                                    <i className="icon" data-feather="settings"></i>
                                </div>
                                <div className="profile-details">
                                    <h4>{t('updatePassword')}</h4>
                                    <img
                                        className="img-fluid arrow"
                                        src={'assets/images/svg/arrow.svg'}
                                        alt="arrow"
                                    />
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/settings" className="profile-box">
                                <div className="profile-img">
                                    <i className="icon" data-feather="lock"></i>
                                </div>
                                <div className="profile-details">
                                    <h4>{t('settings')}</h4>
                                    <img
                                        className="img-fluid arrow"
                                        src={'assets/images/svg/arrow.svg'}
                                        alt="arrow"
                                    />
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/help-center" className="profile-box">
                                <div className="profile-img">
                                    <i className="icon" data-feather="help-circle"></i>
                                </div>
                                <div className="profile-details">
                                    <h4>{t('helpCenter')}</h4>
                                    <img
                                        className="img-fluid arrow"
                                        src={'assets/images/svg/arrow.svg'}
                                        alt="arrow"
                                    />
                                </div>
                            </Link>
                        </li>
                        <li className="profile-list-item--danger">
                            <Link onClick={handleLogout} to="#" className="profile-box">
                                <div className="profile-img">
                                    <i className="icon" data-feather="log-out"></i>
                                </div>
                                <div className="profile-details">
                                    <h4>{t('logOut')}</h4>
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
            </section>
        </>
    );
}

export default ProfileSection;
